// extracted by mini-css-extract-plugin
export default {"container":"WXn6S08kbsQSz8fPmxw5","spinner":"eNLsDm5B5_9MOHL8a1BB"};